(ns frontend.view.nev.kyc.process.source-allocation-split-editor
  (:require [basic-components.inputs.footprint :refer [viewer editor]]
            [common.localization :as loc]
            [frontend.utils :as fu]
            [common.schema.entities.workspace.kyc.kyc-options :as kyc-options]))

(defn view [{:keys [lang-kw question-attribute question-meta answers-atom kyc-process read-only? save!]}]
  (let [answers @answers-atom
        source-split (get answers question-attribute)
        total-percentage-num (->> answers
                                  :kyc-legal-entity/source-of-funds
                                  (set)
                                  (map (fn [source]
                                         (let [value (get source-split source)]
                                           value)))
                                  (apply +))
        total-percentage-str (fu/format-percentage total-percentage-num)
        validation-error (when (fn? (:validation-fn question-meta))
                           ((:validation-fn question-meta) {:answers answers
                                                            :kyc-process kyc-process}))]

    [:table.zap-table.zap-table--striped.zap-table--has-footer.zap-table--width-auto
     [:thead.zap-table__headline
      [:tr.zap-table__row
       [:th.zap-table__headline (loc/tr :source-of-fund-category nil lang-kw)]
       [:th.zap-table__headline.text-right (loc/tr :percentage nil lang-kw)]]]
     [:tbody
      (->> answers
           :kyc-legal-entity/source-of-funds
           (set)
           (map (fn [source]
                  (let [value (get source-split source)]
                    [:tr.zap-table__row
                     {:key (str "source-of-funds-" (name source))}
                     [:td.zap-table__cell
                      [:span
                       (kyc-options/source-of-funds-label source lang-kw)]]
                     [:td.zap-table__cell.text-right.pr-3
                      (if read-only?
                        (str (fu/format-with-separators (* 100 (or value 0)) 2 false 2) "%")
                        [editor {:editor/type          :editor.type/percentage
                                 :value                (or value 0)
                                 :attribute            source
                                 :field/not-clearable? true
                                 :on-save!             (fn [_attribute new-value]
                                                         (swap! answers-atom assoc :kyc-legal-entity/source-of-funds-allocation-split
                                                                (assoc source-split
                                                                       source new-value))
                                                         (deref answers-atom)
                                                         (save!))
                                 :on-blur!             (fn [_e new-value clear-cb!]
                                                         (swap! answers-atom assoc :kyc-legal-entity/source-of-funds-allocation-split
                                                                (assoc source-split
                                                                       source new-value))
                                                         (deref answers-atom)
                                                         (clear-cb!)
                                                         (save!))}])]])))
           (doall))]
     [:tfoot
      [:tr.zap-table__row
       [:td.zap-table__footer-cell.px-2.text-right
        {:col-span "2"}
        [:span.summary-cell.pr-1
         total-percentage-str]
        (when (and validation-error
                   (not read-only?))
          [:p
           {:class "text-sm m-0 text-danger-regular break-words"}
           (loc/tr validation-error nil lang-kw)])]]]]))

